export class ActivityAggregation {
  // 活动聚合页面
  constructor(form) {
    if (form) {
      this.backgroundColor = form.backgroundColor;
      this.backgroundImage = form.backgroundImage;
      this.coverImage = form.coverImage;
      // DTOS是传给后端的值 VOS是后端返回的值
      this.exclusiveActivityAggregationPageAddSeriesEventDTOS = form.exclusiveActivityAggregationPageDetailsSeriesEventVOS || [{
        seriesName: '',
        seriesUnselectedImage: '',
        seriesSelectedImage: '',
      }];
      this.highlightMomentIcon = form.highlightMomentIcon;
      this.id = form.id;
      this.name = form.name;
      this.signUpIcon = form.signUpIcon;
      this.eventCoverImage = form.eventCoverImage;
      this.eventId = form.eventId;
      this.eventName = form.eventName;
      this.beginTime = form.beginTime;
      this.city = form.city;
    } else {
      this.clear();
    }
  }
  removeMain() {
    this.eventId = undefined; // 主活动ID，可为空
    this.eventName = undefined; // 主活动标题，可为空
    this.beginTime = undefined; // 主活动开始日期，可为空
    this.city = undefined; // 主活动城市，可为空
  }
  clear() {
    this.backgroundColor = ''; // 活动背景色
    this.backgroundImage = ''; // 活动背景图
    this.coverImage = ''; // 活动主KV
    this.exclusiveActivityAggregationPageAddSeriesEventDTOS = [{
      seriesName: '',
      seriesUnselectedImage: '',
      seriesSelectedImage: '',
    }]; // 活动聚合页面新增子项目以及活动
    this.highlightMomentIcon = ''; // 高光时刻ICON
    this.id = undefined; // id
    this.name = ''; // 活动标题
    this.signUpIcon = ''; // 活动报名ICON
    this.eventCoverImage = ''; // 主活动背景图片
    this.eventId = undefined; // 主活动ID，可为空
    this.eventName = undefined; // 主活动标题，可为空
    this.beginTime = undefined; // 主活动开始日期，可为空
    this.city = undefined; // 主活动城市，可为空
  }
}
